import './start-screen.css';
import startScreenDefault from '../../assets/start-screen.webp';
import startScreenWhite from '../../assets/start-screen-white.webp';

const isWhiteVariant = window.location.pathname.startsWith('/white');
const startScreenImage = isWhiteVariant ? startScreenWhite : startScreenDefault;

const StartScreen = ({ onStart }) => {
    const handleShop = () => {
        window.open('https://www.boucheron.com/gb/jewelry/jewelry-category/rings.html?p=11', '_blank');
    };

    return (
        <div className="start-screen">
            <img className="start-screen__image" src={startScreenImage} alt="" />
            <button className="start-screen__btn start-screen__btn--ar" onClick={onStart} />
            <button className="start-screen__btn start-screen__btn--shop" onClick={handleShop} />
        </div>
    );
};

export default StartScreen;
